import { get, post, deleteOne, put } from "@/modules/request";
import { PageRequest } from "@/types/api-types";

type ApiGetPresetMediaParams = {
  filter: {
    mateId?: number;
    group?: "Single" | "Multiple";
    type: "Clothes" | "Env" | "Pose";
  };
  pagination?: {
    page?: number;
    perPage?: number;
  };
};

export const ApiGetPresetMedia = (params: ApiGetPresetMediaParams) =>
  get("/PresetMediaPage", params);

export const ApiPostMateLike = (mate: PresetMedia) =>
  post("/MateLike/0", {
    entityType: `App\\Models\\PresetMedia`,
    entityId: mate.id,
    originData: JSON.stringify(mate.originData),
  });

export const ApiPostPoseMedia = (params: any) => post("/PoseMedia/0", params);

export const ApiDeletePoseMedia = (id: number) => deleteOne("/PoseMedia/" + id);

export const ApiGetPosePage = (params: PageRequest<{}>) =>
  get("/PoseMedia/ReadPage", params);

export const ApiPutMateLike = (
  id: number,
  params: {
    title?: string;
    mediaId?: number;
  }
) => put("/MateLike/" + id, params);

export const ApiDeleteMateLike = (id: number) => deleteOne("/MateLike/" + id);

export const ApiPutTextImagePayOne = (id: number) =>
  put("/TextImage/PayOne/" + id);

export const ApiPostImageInpaint = (params: {
  sourceMediaId: number;
  maskMediaId: number;
  prompt: string;
  type: number;
  strength: number;
  isUnlimited: boolean;
}) => post("/ImageInpaint", params);

export const ApiGetImageInpaint = (uuid: string) =>
  get("/ImageInpaint/" + uuid);
  
export const ApiPutChatImagePayOne = (id: number) =>
  put("ChatMessage/PayOneImage/" + id);
